var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ax-layout',[_c('ax-title',{attrs:{"title":"카드 전사기 설정"}}),_c('ax-container',[_c('ax-row-aligned',[_c('ax-card-shadow',{attrs:{"width":"1024","height":"330"}},[_vm._v("설정 컨텍스트")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }